import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LandingPageRoute } from './LandingPageRoute';
import Pricing from '../pages/Pricing';
import { ONBOARDING_PATH } from '../utils/onboarding';

/**
 * Public marketing pricing uses the landing site when configured.
 * Logged-in users always get the app pricing UI (never the CMS marketing page).
 */
export const PricingRoute: React.FC = () => {
  const location = useLocation();
  const isAuthenticated = Boolean(localStorage.getItem('authToken'));

  if (location.search.includes('welcome=true')) {
    return <Navigate to={ONBOARDING_PATH} replace />;
  }

  if (isAuthenticated) {
    return <Pricing />;
  }

  return <LandingPageRoute slug="pricing" fallback={<Pricing />} />;
};
